const COUNTRY_FORMATTING = {
    PK: { en: 'en-PK', 'ur-Latn': 'en-PK', ar: 'en-PK', es: 'en-PK' },
    SA: { en: 'en-GB', ar: 'ar-SA-u-ca-gregory-nu-latn', es: 'en-GB', 'ur-Latn': 'en-GB' },
    AE: { en: 'en-GB', ar: 'ar-AE-u-nu-latn', es: 'en-GB', 'ur-Latn': 'en-GB' },
    QA: { en: 'en-GB', ar: 'ar-QA-u-nu-latn', es: 'en-GB', 'ur-Latn': 'en-GB' },
    CO: { es: 'es-CO', en: 'en-GB', ar: 'en-GB', 'ur-Latn': 'en-GB' },
    GB: { en: 'en-GB', ar: 'en-GB', es: 'en-GB', 'ur-Latn': 'en-GB' },
};
export function normaliseUiLocale(value) {
    if (value === 'ur' || value === 'ur-Latn')
        return 'ur-Latn';
    if (value === 'ar' || value === 'es')
        return value;
    return 'en';
}
export function formattingLocale(country, uiLocale) {
    const ui = normaliseUiLocale(uiLocale);
    const code = (country ?? '').toUpperCase();
    return COUNTRY_FORMATTING[code]?.[ui] ?? 'en-PK';
}
const ZERO_DIGIT_CURRENCIES = new Set(['COP']);
export function currencyDisplayDigits(currency) {
    return ZERO_DIGIT_CURRENCIES.has(currency.toUpperCase()) ? 0 : 2;
}
const MAX_FORMATTERS = 64;
class BoundedCache {
    entries = new Map();
    get(key, build) {
        const found = this.entries.get(key);
        if (found !== undefined)
            return found;
        const value = build();
        if (this.entries.size >= MAX_FORMATTERS) {
            const oldest = this.entries.keys().next().value;
            if (oldest !== undefined)
                this.entries.delete(oldest);
        }
        this.entries.set(key, value);
        return value;
    }
}
const numberFormatters = new BoundedCache();
const dateFormatters = new BoundedCache();
export function moneyFormatter(currency, locale, digits) {
    return numberFormatters.get(`${currency}|${locale}|${digits}`, () => new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }));
}
export function dateTimeFormatter(locale, timeZone, options) {
    return dateFormatters.get(`${locale}|${timeZone}|${options}`, () => new Intl.DateTimeFormat(locale, {
        ...(options === 'time' ? {} : { dateStyle: 'medium' }),
        ...(options === 'date' ? {} : { timeStyle: 'short' }),
        timeZone,
    }));
}
function separatorsOf(locale) {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
    return {
        group: parts.find((part) => part.type === 'group')?.value ?? ',',
        decimal: parts.find((part) => part.type === 'decimal')?.value ?? '.',
    };
}
export function parseMoney(text, locale, digits) {
    const raw = text.trim().replace(/[^\d.,\s  '-]/g, '').trim();
    if (!raw)
        return null;
    const { group, decimal } = separatorsOf(locale);
    const negative = raw.startsWith('-');
    const unsigned = negative ? raw.slice(1) : raw;
    const withoutGroups = unsigned.split(group).join('').replace(/[\s  ']/g, '');
    if (digits === 0) {
        if (!/^\d+$/.test(withoutGroups))
            return null;
        const whole = Number(withoutGroups) * 100;
        return negative ? -whole : whole;
    }
    const normalised = decimal === '.' ? withoutGroups : withoutGroups.split(decimal).join('.');
    if (!/^\d+(\.\d{1,2})?$/.test(normalised))
        return null;
    const [whole, fraction = ''] = normalised.split('.');
    const minor = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    return negative ? -minor : minor;
}
//# sourceMappingURL=formatting.js.map